import React, { } from 'react'

import Grid from '@material-ui/core/Grid'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
// import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Grow from '@material-ui/core/Grow'
import Avatar from '@material-ui/core/Avatar'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  icon: {
    marginTop: 'auto',
    marginBottom: 'auto',
    fontSize: '2.5em'
  },
  warningAlert: {
    width: '60%',
    backgroundColor: '#ffb13f'
  },
  snack: {
    zIndex: '999'
  },
  learnsafeLogo: {
    height: '60px',
    width: '60px'
  }
}))

// Custom Material UI Alert
const Alert = (props) => {
  return <MuiAlert elevation={6} variant='filled' {...props} />
}

/**
 * Pop ups alert when a capture is not assigned a status
 * @param {Object} props props neccesary for alert to handle properly
 * @param {Object.snackOpen} props.snackOpen boolean value that determines when the snack should open
 * @param {Object.onClose} props.onClose function to handle how the snack should close
 * @param {Object.onIgnore} props.onIgnore function to handle what should happen on the event the ignore button is clicked
 */
const StatusSnack = props => {
  const { snackOpen, onClose } = props
  const classes = useStyles()

  const logo = require('../../../assets/images/controls-basic.png')

  return (
    <Snackbar
      open={snackOpen}
      onClose={onClose}
      style={{ top: '15vh' }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      TransitionComponent={Grow}
      className={classes.snack}
    >
      <Alert
        severity='warning'
        onClose={onClose}
        className={`mb-2 mx-auto ${classes.warningAlert}`}
        classes={{ icon: classes.icon }}
        icon={<Avatar src={logo} alt='Logo' className={classes.learnsafeLogo} variant='rounded' />}
      >
        <Grid container direction='column' spacing={1} className='my-auto'>
          <Grid item>
            <Typography variant='h6' align='center' className='font-weight-bold'>Capture must be assigned status!</Typography>
          </Grid>
          <Grid item container direction='row' justify='center'>
            <Typography variant='subtitle2' align='center'>
              Status must be assigned before navigating away from current Capture. To do so, see Status Icon.
            </Typography>
          </Grid>
        </Grid>
      </Alert>
      {/* <Button variant='contained' color='primary' className='mx-5' onClick={onIgnore}><h5 className='my-auto font-weight-bolder'>Ignore</h5></Button> */}
    </Snackbar>
  )
}

export default StatusSnack
